import { Redirect, useHistory } from "react-router";
import IconButton from "../../components/IconButton";
import useAppData from "../../hook/useAppData";
import {
  IconCalendar,
  IconCollaborator,
  IconInvoice,
  IconGestion,
  IconSearch,
  IconComputer,
  IconPeopleProjects,
  IconSpreadsheet,
  IconGraph,
} from "../../icons";
import "./index.scss";
import { Link } from "react-router-dom";
import { ACCESS } from "../Profile/constants";
import logo from "../../image/logoWithoutName.svg";

function Home() {
  const { profileId } = useAppData();

  return <> {profileId ? <>{<RoutesHome />}</> : <Redirect to="/" />}</>;
}

export default Home;

function RoutesHome() {
  const { profileId, accessIds, userId } = useAppData();
  const history = useHistory();

  function handleClickRedirect(route: string) {
    return history.push(`/${route}`);
  }

  const project = accessIds?.includes(ACCESS.PROJECT_write) || accessIds?.includes(ACCESS.PROJECT_read);
  const routineAppointment = accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_read) || accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate);

  return (
    <>
      <div className="containerHome flex flex-col items-center">
        <img src={logo} alt="logo" className="w-36 h-36 -my-6" />
        <h2 className="tittle font-poppins">Bem-vindo(a) ao Sistema IntegraAdmin</h2>
      </div>
      <div className="containerOption center">
        {accessIds?.includes(ACCESS.SELF_INVOICE_all) ? (
          <button onClick={() => handleClickRedirect(`invoice`)} className="btn-home">
            <IconButton className="icon center" icon={IconInvoice} />
            Nota Fiscal
          </button>
        ) : (
          accessIds?.includes(ACCESS.USERS_SELF_REGISTRATION_read) && (
            <button onClick={() => handleClickRedirect(`collaborator/form/${userId}`)} className="btn-home">
              <IconButton className="icon center" icon={IconCollaborator} />
              Perfil
            </button>
          )
        )}

        {accessIds?.includes(ACCESS.TIMESHEET_all) && (
          <button onClick={() => handleClickRedirect("timesheet")} className="btn-home">
            <IconButton className="icon center" icon={IconCalendar} />
            Time Sheet
          </button>
        )}
        {project && accessIds?.includes(ACCESS.CLIENT_all) ? (
          <button className="btn-home">
            <IconButton className="icon center" icon={IconPeopleProjects} />
            Clientes
            <div className="wrapperLinks">
              <Link to={`clients`} className="link">
                Dados Cadastrais
              </Link>
              <Link to={`projects`} className="link">
                Projetos
              </Link>
            </div>
          </button>
        ) : (
          <>
            {project && (
              <button onClick={() => handleClickRedirect("projects")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconPeopleProjects} />
                Projetos
              </button>
            )}
            {accessIds?.includes(ACCESS.CLIENT_all) && (
              <button onClick={() => handleClickRedirect("clients")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconPeopleProjects} />
                Clientes
              </button>
            )}
          </>
        )}
        {routineAppointment && accessIds.includes(ACCESS.APPROVAL_HOURS_read_approve) ? (
          <button className="btn-home">
            <IconButton className="icon center" icon={IconGestion} />
            Gestão de horas
            <div className="wrapperLinks">
              <Link to={`routine-appointment`} className="link">
                Consolidação de Horas
              </Link>
              {profileId !== 4 && (
                <Link to={`approve-hours`} className="link">
                  Aprovação de Horas
                </Link>
              )}
            </div>
          </button>
        ) : (
          <>
            {routineAppointment && (
              <button onClick={() => handleClickRedirect("routine-appointment")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconSearch} />
                Consolidação de Horas
              </button>
            )}
            {accessIds.includes(ACCESS.APPROVAL_HOURS_read_approve) && (
              <button onClick={() => handleClickRedirect("approve-hours")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconInvoice} />
                Aprovação de Horas
              </button>
            )}
          </>
        )}
        {accessIds?.includes(ACCESS.ELETRONICS_all) && accessIds?.includes(ACCESS.IMMOBILIZED_all) ? (
          <>
            <button className="btn-home">
              <IconButton className="icon center" icon={IconComputer} />
              Inventário
              <div className="wrapperLinks">
                <Link to={`immobilized-inventory`} className="link link-double">
                  Imobilizados
                </Link>
                <Link to={`eletronic-inventory`} className="link">
                  Eletrônicos
                </Link>
              </div>
            </button>
          </>
        ) : (
          <>
            {accessIds?.includes(ACCESS.ELETRONICS_all) && (
              <button onClick={() => handleClickRedirect("eletronic-inventory")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconComputer} />
                Eletronicos
              </button>
            )}
            {accessIds?.includes(ACCESS.IMMOBILIZED_all) && (
              <button onClick={() => handleClickRedirect("immobilized-inventory")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconSpreadsheet} />
                Imobilizados
              </button>
            )}
          </>
        )}
        {accessIds?.includes(ACCESS.USERS_DATA_all) && accessIds?.includes(ACCESS.HISTORY_all) ? (
          <button className="btn-home">
            <IconButton className="icon center" icon={IconCollaborator} />
            Profissionais
            <div className="wrapperLinks">
              <Link to={`collaborator`} className="link">
                Dados Cadastrais
              </Link>
              <Link to={`history`} className="link">
                Histórico
              </Link>
            </div>
          </button>
        ) : (
          <>
            {accessIds?.includes(ACCESS.USERS_DATA_all) && (
              <button onClick={() => handleClickRedirect("collaborator")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconCollaborator} />
                Profissionais
              </button>
            )}
            {accessIds?.includes(ACCESS.HISTORY_all) && (
              <button onClick={() => handleClickRedirect("history")} className="btn-home home-project-icon">
                <IconButton className="icon center" icon={IconGraph} />
                Histórico
              </button>
            )}
          </>
        )}
      </div>
    </>
  );
}
